"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OLX = exports.GRUPO_ZAP = void 0;
var OLX = exports.OLX = 'olx';
var GRUPO_ZAP = exports.GRUPO_ZAP = 'grupo-zap';